import { pgTable, text, uuid, foreignKey, boolean } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from './org-id';
import { Profile, Team } from '../schema';
import { Tag } from './tag';
export const Alert = pgTable('alert', {
    ...orgTableBase,
    // library exercise id
    exerciseId: uuid('exercise_id'),
    workoutExerciseId: uuid('workout_exercise_id'),
    workoutId: uuid('workout_id').notNull(),
    athleteId: uuid('athlete_id').notNull(),
    teamId: uuid('team_id').notNull(),
    tagId: uuid('tag'),
    note: text('note'),
    resolved: boolean('resolved').notNull().default(false),
}, (table) => ({
    pk: orgPrimaryKey(table),
    athleteFk: foreignKey({
        columns: [table.orgId, table.athleteId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
    coachFk: foreignKey({
        columns: [table.orgId, table.createdById],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    tagFk: foreignKey({
        columns: [table.orgId, table.tagId],
        foreignColumns: [Tag.orgId, Tag.id],
    }),
}));
//# sourceMappingURL=alert.js.map